/*
 *		Copyright (c) 2011-2014 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

'use strict';

angular.module('access.Nodes')
    .value('SYNC_STATUS', {
        SYNC_2_WAY: 'sync_2_way',
        NOT_SYNCED: 'not_synced'
    })
    .directive('accNodeSyncToggle', ['$modal', '$rootScope', 'SYNC_STATUS', function($modal, $rootScope, SYNC_STATUS) {

        return {
            scope: {
                node: '=accNodeSyncToggle'
            },
            template: '<i ng-class="getIcon()"\
                          ng-if="node.canBeSync()"\
                          ng-click="toggleSync()"\
                          uib-tooltip="{{getTooltip() | translate}}" \
                          data-tooltip-append-to-body="true">\
                        </i>',
            link: function($scope) {
                $scope.loading = false;
                $scope.getIcon = function() {
                    var baseClass = {
                        synced: $scope.node.synced === SYNC_STATUS.SYNC_2_WAY,
                        loading: $scope.loading,
                        loaded: !$scope.loading,
                        'icon-acc-sync': true
                    };

                    return baseClass;
                };

                $scope.getTooltip = function() {
                    return $scope.node.synced == SYNC_STATUS.NOT_SYNCED ? 'nodes_sync_toggle_tooltip_sync' : 'nodes_sync_toggle_tooltip_unsync';
                };

                $scope.toggleSync = function() {
                    var nextSynced;

                    _openModal($scope.node)
                        .then(function(form) {
                            var nodeUpdate = $scope.node.uuid ? {uuid: $scope.node.uuid} : {id: $scope.node.id};

                            nextSynced = form.synced;
                            $scope.loading = true;

                            if (form.synced === SYNC_STATUS.NOT_SYNCED) {
                                return $scope.node.$unsync.call(nodeUpdate);
                            }

                            nodeUpdate.synced = form.synced;
                            nodeUpdate.syncName = form.syncName;

                            return $scope.node.$sync.call(nodeUpdate);
                        })
                        .then(function() {
                            $scope.node.synced = nextSynced;
                        })
                        .finally(function() {
                            $scope.loading = false;
                        });
                }
            }
        };

        function _openModal(node) {
            var $modalScope = $rootScope.$new(true);

            $modalScope.node = node;
            $modalScope.isInitialFolderSync = false;

            $modalScope.hasDesktopClient = $rootScope.account.hasDesktopClient();
            $modalScope.lastSyncWithDesktop = $rootScope.account.lastSyncWithDesktop();

            return $modal.open({
                controller: 'NodeSyncController',
                windowClass: 'sync-dialog',
                backdrop: 'static',
                keyboard: false,
                scope: $modalScope
            }).result;
        }
    }]);

